import axios from 'axios';
import { toast } from 'react-toastify';
export default function useViaCep() {
  async function execute(cep: string, callback?: any) {
    try {
      const response = await axios.get(`https://viacep.com.br/ws/${cep}/json/`);
      if (response.status === 200) {
        if (callback) {
          return callback(response.data);
        }
      }
    } catch (error) {
      toast.error('CEP não encontrado');
    }
  }
  return { execute };
}
